// @ts-nocheck

import styled, { css } from 'styled-components';

import { ON_MY_MATCH_TOGGLE_TRANSITION_DURATION } from '../../constants/ui/mymatch';
import theme from '../../styled-components/dark';
import { MatchViewModes } from '../../types/matchView';

export const Toolbar = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  padding: 0.3em;
  margin: 0 0.6em 0.6em 0.6em;
  border-radius: 10px;
  position: relative;

  .sr-tabs-tab__wrapper {
    background: none;
    position: relative;
    min-width: 2.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.35em 0.6em;
    cursor: pointer;

    .sr-tabs-tab__content {
      height: 1.2em;
    }

    .sr-tabs-tab__icon {
      fill: ${theme.Match.ToolBar.widgets.svg.fillColor};
      height: 1.2em;
      width: 2em;
    }

    &.widget__boxscore {
      .srct-tab__content {
        height: 1em;
      }
    }
    &.widget__standings {
      .srct-tab__content {
        padding-left: 2px;
      }
    }
  }
`;

export const SportradarWrapper = styled.div`
  .sr-lmt-plus {
    &-tabs {
      display: none;
    }

    &-slider__wrapper {
      .st0 {
        fill: unset;
      }
    }
  }

  .sr-bb .srt-win {
    background-color: #00a83f;
  }
  .sr-bb .srt-draw {
    background-color: #f3a000;
  }
  .sr-bb .srt-lose {
    background-color: #dc0000;
  }
`;

export const SportradarInner = styled.div`
  transition: opacity 500ms;
  max-width: 500px;
  margin: 0 auto;
`;

export const ActiveWidgetBackground = styled.div`
  position: absolute;
  left: 0;

  border-radius: 5px;

  transition:
    transform 250ms ease-in-out,
    background-color ${ON_MY_MATCH_TOGGLE_TRANSITION_DURATION}ms ease-in-out;

  ${({ $position: { width, height, top, left } }) => css`
    width: ${width}px;
    height: ${height}px;
    top: ${top}px;
    transform: translateX(${left}px);
  `}

  ${({ $matchViewMode }) =>
    $matchViewMode === MatchViewModes.MY_MATCH
      ? css`
          background-color: rgba(255, 255, 255, 0.1);
        `
      : css`
          background-color: ${theme.Match.ToolBar.widgets.activeColor};
        `}
`;
